import { APP_ID, ApplicationConfig, importProvidersFrom, LOCALE_ID } from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { provideToastr } from 'ngx-toastr';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideNgxMask } from 'ngx-mask';
import { HTTP_INTERCEPTORS, provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import { RECAPTCHA_LOADER_OPTIONS, RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from 'ng-recaptcha';
import { environment } from '../environments/environment';
import localePl from '@angular/common/locales/pl';
import { registerLocaleData } from '@angular/common';
import { APP_ROUTES } from '@www/app.routing';
import { LANGUAGE_KEY } from '@www/app.consts';
import { NgxsModule } from '@ngxs/store';
import { AppState } from '@www/app.state';
import { NgxsRouterPluginModule } from '@ngxs/router-plugin';
import { NgxsFormPluginModule } from '@ngxs/form-plugin';
import { NgxsLoggerPluginModule } from '@ngxs/logger-plugin';
import { NgxsStoragePluginModule, StorageOption } from '@ngxs/storage-plugin';
import { HammerModule, provideClientHydration } from '@angular/platform-browser';
import { NgSelectModule } from '@ng-select/ng-select';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { QuicklinkModule } from 'ngx-quicklink';
import { JwtHelperService } from '@auth0/angular-jwt';
import { HttpErrorInterceptor } from '@www/_interceptors';

registerLocaleData(localePl);

const LOCAL_STORAGE_STATE_VALUES = [LANGUAGE_KEY];

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: APP_ID, useValue: 'serverApp' },
    provideRouter(
      APP_ROUTES,
      withInMemoryScrolling({
        scrollPositionRestoration: 'top',
        anchorScrolling: 'enabled',
      }),
    ),
    provideAnimations(),
    provideToastr({
      timeOut: 10000,
      positionClass: 'toast-top-right',
      preventDuplicates: true,
    }),
    provideNgxMask(),
    provideClientHydration(),
    provideHttpClient(withInterceptorsFromDi(), withFetch()),
    importProvidersFrom(
      NgxsModule.forRoot([AppState], {
        developmentMode: !environment.production,
        selectorOptions: {
          suppressErrors: false,
        },
        compatibility: {
          strictContentSecurityPolicy: true,
        },
      }),
    ),
    importProvidersFrom(NgxsRouterPluginModule.forRoot()),
    importProvidersFrom(NgxsFormPluginModule.forRoot()),
    importProvidersFrom(
      NgxsLoggerPluginModule.forRoot({
        logger: console,
        collapsed: false,
        disabled: environment.production,
      }),
    ),
    importProvidersFrom(
      NgxsStoragePluginModule.forRoot({
        storage: StorageOption.LocalStorage,
        keys: [...LOCAL_STORAGE_STATE_VALUES],
      }),
    ),
    importProvidersFrom(BsDropdownModule.forRoot()),
    importProvidersFrom(QuicklinkModule),
    importProvidersFrom(NgSelectModule),
    importProvidersFrom(HammerModule),
    importProvidersFrom(RecaptchaV3Module),
    JwtHelperService,
    { provide: APP_ID, useValue: 'serverApp' },
    { provide: LOCALE_ID, useValue: 'pl-PL' },
    {
      provide: RECAPTCHA_LOADER_OPTIONS,
      useFactory: (locale: string) => ({
        onBeforeLoad(url: URL) {
          url.searchParams.set('hl', locale);
          return { url };
        },
      }),
      deps: [LOCALE_ID],
    },
    {
      provide: RECAPTCHA_V3_SITE_KEY,
      useValue: environment.recaptchaV3SiteKey,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true,
    },
  ],
};
